import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';
import { AuthProvider, useAuth } from './context/AuthContext.jsx';
import Layout from './components/Layout.jsx';
import Login from './pages/Login.jsx';
import Register from './pages/Register.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Clients from './pages/Clients.jsx';
import Articles from './pages/Articles.jsx';
import Transactions from './pages/Transactions.jsx';
import Released from './pages/Released.jsx';
import Ledger from './pages/Ledger.jsx';

import Master from './pages/Master.jsx';
import Vadla from './pages/Vadla.jsx';
import Reports from './pages/Reports.jsx';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner size="xl" />
      </Box>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
      />
      <Route
        path="/dashboard"
        element={(
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/master"
        element={(
          <ProtectedRoute>
            <Layout>
              <Master />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/clients"
        element={(
          <ProtectedRoute>
            <Layout>
              <Clients />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/articles"
        element={(
          <ProtectedRoute>
            <Layout>
              <Articles />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/transactions"
        element={(
          <ProtectedRoute>
            <Layout>
              <Transactions />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/released"
        element={(
          <ProtectedRoute>
            <Layout>
              <Released />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/ledger"
        element={(
          <ProtectedRoute>
            <Layout>
              <Ledger />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/vadla"
        element={(
          <ProtectedRoute>
            <Layout>
              <Vadla />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/reports"
        element={(
          <ProtectedRoute>
            <Layout>
              <Reports />
            </Layout>
          </ProtectedRoute>
        )}
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
